<script setup lang="ts">
  import ModalsPosAdminGrantCode from '@/components/modals/pos-admin-grant/ModalsPosAdminGrantCode.vue';
  import { useModal } from '@/composition/use-modal';

  const modal = useModal();

  const openTokenModal = () => {
    modal.show(
      ModalsPosAdminGrantCode,
      {},
      {
        name: 'pos-admin-grant-code',
        adaptive: true,
        height: 'auto',
        scrollable: false,
        maxWidth: window.innerWidth * 0.95,
        width: 560,
        transition: 'none',
        clickToClose: true,
      }
    );
  };
</script>

<template>
  <div class="pos-auth-widget">
    <div class="widget-header">
      <div class="icon-wrapper">
        <v-icon size="18">mdi-shield-key-outline</v-icon>
      </div>
      <span class="title">Autorización POS</span>
    </div>

    <p class="description">
      Genera un token temporal para autorizar acciones en el nuevo POS.
    </p>

    <button class="generate-btn" @click="openTokenModal">
      <v-icon size="16">mdi-key-plus</v-icon>
      <span>Generar token</span>
    </button>
  </div>
</template>

<style scoped lang="scss">
  .pos-auth-widget {
    @apply tw-bg-gradient-to-br tw-from-amber-50 tw-to-orange-50;
    @apply tw-rounded-xl tw-p-4;

    .widget-header {
      @apply tw-flex tw-items-center tw-gap-2 tw-mb-2;

      .icon-wrapper {
        @apply tw-w-7 tw-h-7 tw-rounded-lg;
        @apply tw-bg-gradient-to-br tw-from-amber-400 tw-to-orange-500;
        @apply tw-flex tw-items-center tw-justify-center;
        @apply tw-shadow-sm;

        .v-icon {
          @apply tw-text-white;
        }
      }

      .title {
        @apply tw-text-sm tw-font-semibold tw-text-neutral-800;
      }
    }

    .description {
      @apply tw-text-xs tw-text-neutral-600 tw-leading-relaxed;
      @apply tw-mb-3;
    }

    .generate-btn {
      @apply tw-w-full tw-py-2 tw-px-3;
      @apply tw-bg-gradient-to-r tw-from-amber-500 tw-to-orange-500;
      @apply tw-text-white tw-text-xs tw-font-medium;
      @apply tw-rounded-lg tw-border-0;
      @apply tw-flex tw-items-center tw-justify-center tw-gap-1.5;
      @apply tw-cursor-pointer;
      @apply tw-transition-all tw-duration-200;
      @apply tw-shadow-sm;

      &:hover {
        @apply tw-from-amber-600 tw-to-orange-600;
        @apply tw-shadow-md;
        transform: translateY(-1px);
      }

      &:active {
        transform: translateY(0);
        @apply tw-shadow-sm;
      }

      .v-icon {
        @apply tw-text-white;
      }
    }
  }
</style>
